import { apiUrl } from "../Utils/Environment";

const ApiUrlConstant = {

  // =================================
  // DashBoard API for admin         |
  // =================================
  dashboardStats: () => `${apiUrl}/getInspectionForProjectTypes`,
  getTopinspectors: () => `${apiUrl}/getTopinspectors`,

  // =================================
  // Login Endpoint's                |
  // =================================
  loginService: () => `${apiUrl}/login`,
  logoutService: () => `${apiUrl}/logout`,
  forgotPasswordService: () => `${apiUrl}/forgotPassword`,
  createPasswordService: () => `${apiUrl}/create-password`,
  resetPasswordService: () => `${apiUrl}/reset-password`,
  verifyTokenService: () => `${apiUrl}/verify-token`,

  // =================================
  // Get logged in user's profile    |
  // =================================

  profileService: () => `${apiUrl}/profile`,
  updateProfile: () => `${apiUrl}/update-profile`,

  // =================================
  // Dashboard Section               |
  // =================================
  fetchDashboardContent: () => `${apiUrl}/dashboard`,

  // =================================
  // User Management Endpoint's      |
  // =================================
  listUserManagement: () => `${apiUrl}/getUsers`,
  addUserService: () => `${apiUrl}/addUser`,
  getUser: (id) => `${apiUrl}/getUsers?id=${id}`,
  updateUser: (id) => `${apiUrl}/updateUser?id=${id}`,
  getRole: () => `${apiUrl}/getActiveRoles`,
  resendEmail: () => `${apiUrl}/resendEmail`,
  getAllUserList: () => `${apiUrl}/getAllUsers`,
  userListForProject: () => `${apiUrl}/getUserForProject`,
  changePassword: () => `${apiUrl}/change-password`,

  // =================================
  // project Management Endpoint's      |
  // =================================
  projectListing: () => `${apiUrl}/getProjects`,
  getProject: (id) => `${apiUrl}/getProjectDetails?projectId=${id}`,
  getStates: () => `${apiUrl}/getState`,
  getProjectTypes: () => `${apiUrl}/getProjectTypes`,
  createProject: () => `${apiUrl}/createProject`,
  deleteProject: () => `${apiUrl}/deleteProject`,
  archiveProject: () => `${apiUrl}/archiveProject`,
  updateProject: () => `${apiUrl}/updateProject`,
  getAllProjectList: () => `${apiUrl}/getAllProject`,

  // =================================
  // Template Management Endpoint's  |
  // =================================
  getTemplates: () => `${apiUrl}/getTemplates`,
  createTemplate: () => `${apiUrl}/addTemplate`,
  deleteTemplate: () => `${apiUrl}/deleteTemplate`,
  getdefaultTemplate: () => `${apiUrl}/getFormData`,
  getTemplate: () => `${apiUrl}/getTemplates`,
  getAllTemplate: () => `${apiUrl}/getAllTemplate`,
  cloneTemplate: () => `${apiUrl}/cloneTemplate`,
  updateTemplate: (id) => `${apiUrl}/updateTemplate?template_id=${id}`,
  saveResponse: () => `${apiUrl}/saveTemplateResponse`,
  getTemplateLogs: () => `${apiUrl}/getTemplateLogs`,
  getTemplateLogsById: () => `${apiUrl}/getTemplateLogsById`,
  getTemplateResponse: () => `${apiUrl}/getTemplateResponse`,
  getPhotoAccessUrls: () => `${apiUrl}/getPhotoAccessUrls`,
  archiveTemplate: () => `${apiUrl}/archiveTemplate`,

  // ===================================
  // Data Library Management Endpoint's |
  // ===================================
  dataLibraryListing: () => `${apiUrl}/getDataLibrary`,
  deleteDataLibrary: () => `${apiUrl}/deleteDataLibrary`,
  addDataLibraryListing: () => `${apiUrl}/createDataLibrary`,
  getDataLibraryById: () => `${apiUrl}/getDataLibraryById`,
  updateDataLibraryById: () => `${apiUrl}/updateDataLibrary`,

  // ===================================
  // Inspection Management Endpoint's |
  // ===================================
  inspectionListing: () => `${apiUrl}/getInspection`,
  getInspection: (id) => `${apiUrl}/getInspection?id=${id}`,
  addInspection: () => `${apiUrl}/createInspection`,
  deleteInspection: () => `${apiUrl}/deleteInspection`,
  updateInspection: (id) => `${apiUrl}/updateInspection?id=${id}`,
  getInspectionforProject: () => `${apiUrl}/getInspetionOfProject`,
  archiveInspection: () => `${apiUrl}/archiveInspection`,
  cloneInspection: () => `${apiUrl}/cloneInspection`,
  inspectionStarted: () => `${apiUrl}/inspectionStarted`,
  reportGenerate: () => `${apiUrl}/reportGenerate`,

  getAuditLogs: () => `${apiUrl}/getAuditLogs`,
  getAuditLogsById: () => `${apiUrl}/getAuditLogsById`,



  addBodyAndPartDataService: () => `${apiUrl}/add-body-part`,
  getPartDetailsService: (id) => `${apiUrl}/get-body-part/${id}`,
  updatePartDetailsService: (id) => `${apiUrl}/update-body-part/${id}`,

  // =================================
  // Body Management Endpoint's For Parts |
  // =================================
  addPartNew: () => `${apiUrl}/add-part`,
  getParts: () => `${apiUrl}/get-parts`,
  updateParts: (id) => `${apiUrl}/update-part/${id}`,

  // =================================
  // Body Management Endpoint's For Package |
  // =================================
  // addPartNew: () => `${apiUrl}/add-part`,
  getPackages: () => `${apiUrl}/all-packages`,
  getRecommendation: () => `${apiUrl}/get-recommendation`,
  // updateParts: (id) => `${apiUrl}/update-part/${id}`,

  // =================================
  // Clinic Management Endpoint's |
  // =================================
  listClinics: () => `${apiUrl}/users`,
  addClinic: () => `${apiUrl}/add-user`,
  updateClinic: (id) => `${apiUrl}/update-user/${id}`,
  loginToClinic: (clinicId) => `${apiUrl}/login-as/${clinicId}`,

  // =================================
  // Content Management Endpoint's | Public
  // =================================
  fetchPublicContent: () => `${apiUrl}/public-content`,

  // =================================
  // Content Management Endpoint's |
  // =================================
  fetchContent: () => `${apiUrl}/content`,
  updateContent: () => `${apiUrl}/update-content`,
  updateDesign: () => `${apiUrl}/update-design`,
  resetDesign: () => `${apiUrl}/reset-design`,
  changeLogo: () => `${apiUrl}/change-logo`,

  // =================================
  // Images Management Endpoint's |
  // =================================
  fetchImages: () => `${apiUrl}/all-images`,
  updateImages: () => `${apiUrl}/update-part`,
  updateDashedImages: () => `${apiUrl}/update-dashed-part`,

  // =================================
  // Consultation Endpoint's |
  // =================================
  addConsultation: () => `${apiUrl}/consultation`,
  consultationsList: () => `${apiUrl}/consultations`,
  editconsultation: (_id) => `${apiUrl}/update-consultation/${_id}`,
  getPackageDetails: () => `${apiUrl}/get-recommendation`,

  // =================================
  // Packages Management Endpoint's |
  // =================================
  listPackages: () => `${apiUrl}/packages`,
  removeFiles: () => `${apiUrl}/remove-file`,
  addPackages: () => `${apiUrl}/new-package`,
  updatePackage: (id) => `${apiUrl}/update-package/${id}`,
  getPackage: (id) => `${apiUrl}/get-package/${id}`,
};

export default ApiUrlConstant;
